import {Stack} from '@mui/material'
import React from 'react'
import Label from './Label'
import NoNetWorkIcon from '../../svg/NoNetWorkIcon'

export default function NoNetWork({children}: any) {
  return (
    <Stack position={'relative'}>
      {localStorage.getItem('errNetwork') == 'true' && (
        <Stack position={'absolute'} gap='35px' mt='32px' width={'100%'} alignItems={'center'}>
          <NoNetWorkIcon />
          <Stack gap='4px' alignItems={'center'}>
            <Label fs='18px' fw='600' lineHeight='38px' text='Oops!' />
            <Label fs='18px' fw='400' lineHeight='38px' text='noConaction' />
          </Stack>
        </Stack>
      )}
      <Stack sx={{opacity: localStorage.getItem('errNetwork') == 'true' ? 0 : 1}}>{children}</Stack>
    </Stack>
  )
}
